import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "z-40" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("span", null, "管理ユーザ一覧", -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("span", null, "ポイント一括付与履歴検索", -1);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("span", null, "ポイント一括付与対象検索", -1);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("span", null, "ポイント取引履歴", -1);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("span", null, "クーポン検索", -1);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("span", null, "クーポン生成", -1);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("span", null, "クーポン取引履歴", -1);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("span", null, "クーポン一括付与履歴検索", -1);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("span", null, "ポイント交換倍率一覧", -1);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("span", null, "ポイント対象外商品コード検索", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    const _component_Slide = _resolveComponent("Slide");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Slide, { closeOnNavigation: true }, {
            default: _withCtx(() => [
                _createVNode(_component_router_link, {
                    to: "/user",
                    id: "user"
                }, {
                    default: _withCtx(() => [
                        _hoisted_2
                    ]),
                    _: 1
                }),
                _createVNode(_component_router_link, {
                    to: "/pointBulkGrantHistory",
                    id: "PointBulkGrantHistory"
                }, {
                    default: _withCtx(() => [
                        _hoisted_3
                    ]),
                    _: 1
                }),
                _createVNode(_component_router_link, {
                    to: "/bulkPointAllocationTargetSearch",
                    id: "BulkPointAllocationTargetSearch"
                }, {
                    default: _withCtx(() => [
                        _hoisted_4
                    ]),
                    _: 1
                }),
                _createVNode(_component_router_link, {
                    to: "/pointTransactionHistory",
                    id: "PointTransactionHistory"
                }, {
                    default: _withCtx(() => [
                        _hoisted_5
                    ]),
                    _: 1
                }),
                _createVNode(_component_router_link, {
                    to: "/couponSearch",
                    id: "CouponSearch"
                }, {
                    default: _withCtx(() => [
                        _hoisted_6
                    ]),
                    _: 1
                }),
                _createVNode(_component_router_link, {
                    to: "/couponGeneration",
                    id: "CouponGeneration"
                }, {
                    default: _withCtx(() => [
                        _hoisted_7
                    ]),
                    _: 1
                }),
                _createVNode(_component_router_link, {
                    to: "/couponTransactionHistory",
                    id: "CouponTransactionHistory"
                }, {
                    default: _withCtx(() => [
                        _hoisted_8
                    ]),
                    _: 1
                }),
                _createVNode(_component_router_link, {
                    to: "/couponBulkGrantHistory",
                    id: "CouponBulkGrantHistory"
                }, {
                    default: _withCtx(() => [
                        _hoisted_9
                    ]),
                    _: 1
                }),
                _createVNode(_component_router_link, {
                    to: "/searchPointExchangeMagnification",
                    id: "searchPointExchangeMagnification"
                }, {
                    default: _withCtx(() => [
                        _hoisted_10
                    ]),
                    _: 1
                }),
                _createVNode(_component_router_link, {
                    to: "/searchPointExcludedProductCode",
                    id: "searchPointExcludedProductCode"
                }, {
                    default: _withCtx(() => [
                        _hoisted_11
                    ]),
                    _: 1
                })
            ]),
            _: 1
        })
    ]));
}
